import settings from "../../../configs/settings";
import { Box, Button, Grid, Tab, Tabs, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useContext, useEffect, useState } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import BuscarArmazonAnteojoSolDialog from "./BuscarArmazonAnteojoSolDialog";
import { getArmazonAnteojoSol } from "../../../project/services/ArticuloService";
import { getPorcentajeDescuento } from "../../../project/services/ArticuloService";
import Message from "../../../project/utils/Message";
import { formatMoney } from "../../utils/utils"
import { limpiaCodigo } from "../../utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";

//
// ################################################################################
//
const ArregloPaseCristales = () => {
  const [openDialogBusquedaAvanzada, setOpenDialogBusquedaAvanzada] = useState(false);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const {
    arregloTabNuevoDeCliente,
    setArregloTabNuevoDeCliente,
    initialArregloArmazonNuevo,
    arregloArmazonNuevo,
    setArregloArmazonNuevo,
    handleChangeArregloArmazonNuevo,
    initialArregloArmazonCliente,
    arregloArmazonCliente,
    handleChangeArregloArmazonCliente,
    setArregloArmazonCliente,
    gaAction,
  } = useContext(GestionAtencionContext);

  let {
    arregloArmazonNuevoCodigoArmazon,
    arregloArmazonNuevoDescripcionArmazon,
    arregloArmazonNuevoMarcaArmazon,
    arregloArmazonNuevoModeloArmazon,
    arregloArmazonNuevoCategoriaArmazon,
    arregloArmazonNuevoMaterialArmazon,
    arregloArmazonNuevoFormatoArmazon,
    arregloArmazonNuevoCalibreArmazon,
    arregloArmazonNuevoTipoArmazon,
    arregloArmazonNuevoColorLenteArmazon,
    arregloArmazonNuevoPrecioVentaArmazon,
    arregloArmazonNuevoPrecioVentaContadoArmazon,
    // arregloArmazonNuevoPrecioVentaOriginalArmazon,
  } = arregloArmazonNuevo;

  let { arregloArmazonClienteDescripcion } = arregloArmazonCliente;
  //
  // ################################################################################
  //
  useEffect(() => {
    if (arregloTabNuevoDeCliente === 0) {
      setArregloArmazonCliente(initialArregloArmazonCliente);
    } else {
      setArregloArmazonNuevo(initialArregloArmazonNuevo);
    }
  }, [
    arregloTabNuevoDeCliente,
    setArregloArmazonCliente,
    initialArregloArmazonCliente,
    setArregloArmazonNuevo,
    initialArregloArmazonNuevo,
  ]);
  //
  // ################################################################################
  //
  const handleChangeTab = (event, newValue) => {
    setArregloTabNuevoDeCliente(newValue);
  };
  //
  // ################################################################################
  //
  const handleBuscarArmazonAnteojoSol = () => {
    if (arregloArmazonNuevoCodigoArmazon === "") {
      return;
    }
    buscarArmazonAnteojoSol(arregloArmazonNuevoCodigoArmazon);
  };
  //
  // ################################################################################
  //
  const buscarArmazonAnteojoSol = async (parArregloArmazonNuevoCodigoArmazon) => {

    parArregloArmazonNuevoCodigoArmazon = limpiaCodigo(parArregloArmazonNuevoCodigoArmazon).toUpperCase();

    setArregloArmazonNuevo({
      ...arregloArmazonNuevo,
      arregloArmazonNuevoCodigoArmazon: parArregloArmazonNuevoCodigoArmazon,
    });

    let _params = {
      codigo: parArregloArmazonNuevoCodigoArmazon,
      valida_existencia: 'S',
    };
    setIsDoingSomething(true);
    const response = await getArmazonAnteojoSol(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      let _params = {
        tipoArticulo: response.data.data[0].descripcion_tipo_articulo,
        id: response.data.data[0].id_ar_as_marca,
      };

      setIsDoingSomething(true);
      const responseDescuento = await getPorcentajeDescuento(_params);
      setIsDoingSomething(false);

      let _porcentajeDescuento = 0;
      if (responseDescuento.ok) {
        _porcentajeDescuento = responseDescuento.data.data.porcentaje_descuento;
      }
      let _precioVentaContado =
        response.data.data[0].precio_venta_lista - (response.data.data[0].precio_venta_lista * _porcentajeDescuento) / 100;

      const armazonArregloSol = {
        arregloArmazonNuevoIdArmazon: response.data.data[0].id,
        arregloArmazonNuevoCodigoArmazon: response.data.data[0].codigo,
        arregloArmazonNuevoDescripcionArmazon: response.data.data[0].descripcion,
        arregloArmazonNuevoMarcaArmazon: response.data.data[0].descripcion_ar_as_marca,
        arregloArmazonNuevoModeloArmazon: response.data.data[0].modelo,
        arregloArmazonNuevoCategoriaArmazon: response.data.data[0].descripcion_ar_as_categoria,
        arregloArmazonNuevoMaterialArmazon: response.data.data[0].descripcion_ar_as_material,
        arregloArmazonNuevoFormatoArmazon: response.data.data[0].descripcion_ar_as_formato,
        arregloArmazonNuevoCalibreArmazon: response.data.data[0].valor_ar_as_calibre,
        arregloArmazonNuevoTipoArmazon: response.data.data[0].descripcion_ar_as_tipo,
        arregloArmazonNuevoColorLenteArmazon:
          response.data.data[0].descripcion_as_color_lente || "",
        arregloArmazonNuevoPrecioVentaArmazon: response.data.data[0].precio_venta_lista,
        arregloArmazonNuevoPrecioVentaOriginalArmazon: response.data.data[0].precio_venta_lista,
        arregloArmazonNuevoPorcentajeDescuentoArmazon: _porcentajeDescuento,
        arregloArmazonNuevoPrecioVentaContadoArmazon: _precioVentaContado,
        arregloArmazonClienteDescripcion: "",
      };
      setArregloArmazonNuevo(armazonArregloSol);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
      setArregloArmazonNuevo(initialArregloArmazonNuevo);
    }
  };
  //
  // ################################################################################
  //
  const handleClickOpenBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(true);
  };
  //
  // ################################################################################
  //
  const handleCloseBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(false);
  };
  //
  // ################################################################################
  //
  const handleSelectBusquedaAvanzada = async (articulo) => {
    setOpenDialogBusquedaAvanzada(false);
    buscarArmazonAnteojoSol(articulo.codigo);
  };
  //
  // ################################################################################
  //
  const handleLimpiarArmazonNuevo = () => {
    setArregloArmazonNuevo(initialArregloArmazonNuevo);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Tabs
        value={arregloTabNuevoDeCliente}
        onChange={handleChangeTab}
        aria-label="basic tabs example"
      >
        <Tab label="Nuevo" disabled={gaAction.cu === "view" ? true : false} />
        <Tab label="De Cliente" disabled={gaAction.cu === "view" ? true : false} />
      </Tabs>
      <Box sx={{ m: 1, px: 1, pb: 1 }}>
        {arregloTabNuevoDeCliente === 0 && (
          // arreglo nuevo
          <>
            <Grid container spacing={1}>
              <Grid item md={6}>
                {/* codigo de armazon */}

                <TextField
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigo-armazon"
                  label="Código del Armazón"
                  variant="outlined"
                  size="small"
                  name="arregloArmazonNuevoCodigoArmazon"
                  value={arregloArmazonNuevoCodigoArmazon}
                  onChange={handleChangeArregloArmazonNuevo}
                  disabled={arregloArmazonNuevoDescripcionArmazon !== ""}
                />
              </Grid>

              {gaAction.cu !== "view" && (
                <>
                  <Grid item md={6}>
                    {/* boton buscar */}

                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      onClick={handleBuscarArmazonAnteojoSol}
                      startIcon={<SearchIcon />}
                      disabled={
                        arregloArmazonNuevoCodigoArmazon === "" ||
                        arregloArmazonNuevoDescripcionArmazon !== ""
                      }
                    >
                      Buscar
                    </Button>

                    {/* boton busqueda avanzada */}

                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      onClick={handleClickOpenBusquedaAvanzada}
                      startIcon={<SavedSearchIcon />}
                    >
                      Búsqueda Avanzada
                    </Button>

                    {/* boton limpiar */}

                    <Button
                      sx={{ mr: 1 }}
                      variant="outlined"
                      onClick={handleLimpiarArmazonNuevo}
                      startIcon={<CleaningServicesIcon />}
                      disabled={arregloArmazonNuevoCodigoArmazon === ""}
                    >
                      Limpiar
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>

            <Grid container spacing={1}>
              <Grid item md={6}>
                {/* descripcion del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="descripcion-armazon"
                  label="Descripción"
                  variant="outlined"
                  size="small"
                  name="arregloArmazonNuevoDescripcionArmazon"
                  value={arregloArmazonNuevoDescripcionArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* marca del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="marca-armazon"
                  label="Marca"
                  variant="outlined"
                  size="small"
                  name="arregloArmazonNuevoMarcaArmazon"
                  value={arregloArmazonNuevoMarcaArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* modelo del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="modelo-armazon"
                  label="Modelo"
                  variant="outlined"
                  size="small"
                  name="arregloArmazonNuevoModeloArmazon"
                  value={arregloArmazonNuevoModeloArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* categoria del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="categoria-armazon"
                  label="Categoría"
                  variant="outlined"
                  size="small"
                  name="arregloArmazonNuevoCategoriaArmazon"
                  value={arregloArmazonNuevoCategoriaArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* material del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="material-armazon"
                  label="Material"
                  variant="outlined"
                  size="small"
                  name="arregloArmazonNuevoMaterialArmazon"
                  value={arregloArmazonNuevoMaterialArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* formato del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="formato-armazon"
                  label="Formato"
                  variant="outlined"
                  size="small"
                  name="arregloArmazonNuevoFormatoArmazon"
                  value={arregloArmazonNuevoFormatoArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* calibre del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="calibre-armazon"
                  label="Calibre"
                  variant="outlined"
                  size="small"
                  name="arregloArmazonNuevoCalibreArmazon"
                  value={arregloArmazonNuevoCalibreArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* tipo del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="tipo-armazon"
                  label="Tipo"
                  variant="outlined"
                  size="small"
                  name="arregloArmazonNuevoTipoArmazon"
                  value={arregloArmazonNuevoTipoArmazon}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                {/* color del lente del armazon */}
                <TextField
                  sx={{ width: "100%" }}
                  id="color-lente-armazon"
                  label="Color de Lente"
                  variant="outlined"
                  size="small"
                  name="arregloArmazonNuevoColorLenteArmazon"
                  value={arregloArmazonNuevoColorLenteArmazon}
                  disabled
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item sm={6}>
                {/* total del armazon */}
                <Typography
                  component="div"
                  align="right"
                  sx={{
                    p: 1,
                    mt: 2,
                    backgroundColor: "LightBlue",
                    borderRadius: "5px",
                    fontWeight: "bold",
                  }}
                >
                  PRECIO DE LISTA: {formatMoney(arregloArmazonNuevoPrecioVentaArmazon)}
                </Typography>
              </Grid>
              <Grid item sm={6}>
                {/* total del armazon */}
                <Typography
                  component="div"
                  align="right"
                  sx={{
                    p: 1,
                    mt: 2,
                    backgroundColor: "LightBlue",
                    borderRadius: "5px",
                    fontWeight: "bold",
                  }}
                >
                  PRECIO DE CONTADO: {formatMoney(arregloArmazonNuevoPrecioVentaContadoArmazon)}
                </Typography>
              </Grid>
            </Grid>
          </>
        )}
        {arregloTabNuevoDeCliente === 1 && (
          // arreglo de cliente
          <>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {/* descripcion del arreglo del cliente */}
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  id="armazon-cliente-descripcion"
                  label="Estado de la Montura"
                  multiline
                  maxRows={3}
                  name="arregloArmazonClienteDescripcion"
                  value={arregloArmazonClienteDescripcion}
                  onChange={handleChangeArregloArmazonCliente}
                  disabled={gaAction.cu === "view"}
                />
              </Grid>
            </Grid>
          </>
        )}
      </Box>

      {/* >>>> Diálogo de búsqueda de armazones o arreglos de sol */}

      {openDialogBusquedaAvanzada && (
        <BuscarArmazonAnteojoSolDialog
          open={openDialogBusquedaAvanzada}
          onClose={handleCloseBusquedaAvanzada}
          onSelect={handleSelectBusquedaAvanzada}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ArregloPaseCristales;
